import { render } from "./TaxInvoice.vue?vue&type=template&id=25fca88a"
import script from "./TaxInvoice.vue?vue&type=script&lang=js"
export * from "./TaxInvoice.vue?vue&type=script&lang=js"

import "./TaxInvoice.vue?vue&type=style&index=0&id=25fca88a&lang=css"

import exportComponent from "/var/www/html/letmein_selfpayment/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__